/* LPM quizzes: consent-gated answers and verified-order attribution. */
(() => {
  const timeoutSignal = ms => { const controller = new AbortController(); setTimeout(() => controller.abort(), ms); return controller.signal; };
  if (window.LPMQuizTracking) return;
  const endpoint = 'https://calor-two.vercel.app/api/quiz';
  const key = 'lpm-quiz-attribution-v3';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const root = window.Shopify?.routes?.root || '/';
  let context = null, sequence = 0, model = {version: 'rules-v1', segments: {}}, modelRequest;
  const read = () => { try { const value = JSON.parse(sessionStorage.getItem(key)); return value && Date.now() - value.time < 86400000 ? value : null; } catch { return null; } };
  const write = value => { try { value ? sessionStorage.setItem(key, JSON.stringify(value)) : sessionStorage.removeItem(key); } catch { /* Quiz still works without storage. */ } };
  function send(event, answers = {}, products = [], step = null) {
    if (!context || (!allowed() && event !== 'revoke')) return;
    const body = JSON.stringify({id: crypto.randomUUID(),run:context.run,type:context.type,version:context.version||'2026-09-v3',event,answers,products,step,consent:true,sequence:++sequence,currency:context.currency,locale:context.locale,device:innerWidth<801?'mobile':'desktop',model:model.version});
    context.sequence = sequence; write(context);
    // Email states can arrive while earlier quiz requests are still being processed.
    // Reuse the same UUID on transient failures: the collector deduplicates inserts.
    const run = context.run;
    async function deliver(attempt = 0) {
      let response;
      try { response = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'text/plain'},body,keepalive:true}); } catch { /* Treat transport failures like temporary unavailability. */ }
      if (event.startsWith('email_') && (!response || response.status === 503) && attempt < 2 && allowed() && context?.run === run) {
        setTimeout(() => { if (allowed() && context?.run === run) deliver(attempt + 1); }, attempt ? 3500 : 1500);
      }
    }
    deliver();
  }
  async function attribute(value) {
    if (value && !allowed()) return;
    const attributes = {'Quiz run':value?.run || '', 'Quiz tipo':value?.type || '', 'Quiz version':value?(value.version || '2026-09-v3'):''};
    return fetch(root+'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes}),keepalive:true,signal:timeoutSignal(2500)}).catch(()=>{});
  }
  const api = {
    allowed,
    visit(type,currency,locale) {
      if (!allowed()) return;
      context={run:crypto.randomUUID(),type,currency,locale,time:Date.now(),version:'2026-09-v4',started:false,completed:false};sequence=0;
      send('view');write(context);return context;
    },
    resume(run,type,locale) {
      if (!allowed() || !run) return null;
      const saved = read();
      if (!saved || saved.run !== run || saved.type !== type || saved.locale !== locale) return null;
      context = saved; sequence = Number(saved.sequence) || 0; return context;
    },
    start(type,currency,locale,answers) {
      if (!allowed()) return;
      if (!context || context.type !== type) api.visit(type,currency,locale);
      if (context.started) return;
      context.started=true;send('start',answers);write(context);
    },
    event(event,answers,products=[],step=null) {send(event,answers,products,step);},
    complete(answers,products) {if(!allowed()||!context)return;context.completed=true;send('results',answers,products);write(context);attribute(context);},
    context:()=>allowed()?context:null,
    model:()=>model,
    async loadModel() {
      if (!allowed()) return;
      if (!modelRequest) modelRequest=fetch('https://calor-two.vercel.app/api/quiz-model',{signal:timeoutSignal(1200)}).then(r=>r.ok?r.json():null).then(data=>{if(data&&/^[a-z0-9-]{1,50}$/.test(data.version)&&data.segments&&typeof data.segments==='object')model=data;}).catch(()=>{});
      return modelRequest;
    },
    async beforeBuy() {if(allowed()&&context?.completed)return attribute(context);},
    reset() {context=null;sequence=0;write(null);if(allowed())attribute(null);}
  };
  window.LPMQuizTracking=api;
  function privacyChanged() {
    if (!allowed()) {
      const saved = context || read();
      if(saved){context=saved;send('revoke');attribute(null);}
      context=null;sequence=0;write(null);return;
    }
    // Restore only the current tab's consented quiz, never fingerprint across visitors.
    if(!document.querySelector('lpm-jewelry-quiz')) {
      context=read();if(context && (context.completed || !context.version))attribute(context);
    }
    document.dispatchEvent(new CustomEvent('lpm:quiz-tracking-ready'));
  }
  document.addEventListener('visitorConsentCollected',privacyChanged);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded',privacyChanged);
  if(window.Shopify?.loadFeatures&&!window.Shopify.customerPrivacy)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>privacyChanged());
  else privacyChanged();
})();
